import React from "react";
import { ImportExport } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import ConfirmDialog from "../../common/ConfirmDialog";
import Service from "../../../util/Service";


export default function EditarPortalExportComp(props) {
    const { pagina, placement } = props;

    const [open, setOpen] = React.useState(false);

    const handleClick = (event) => {
        setOpen(true);
    };

    function handleExportClick() {
        console.log('>>>handleExportClick<<<');

        
        Service.DOWNLOAD("/api/security/paginaHtml/export/"+pagina.id, pagina.nome+".zip").then(ret => {
            console.log(ret);
        });
    }

    return (
        <React.Fragment>
            <Tooltip title="Exportar Pagina" placement={placement}>
                <IconButton
                    size="large"
                    color="inherit"
                    onClick={handleClick}
                >
                    <ImportExport />
                </IconButton>
            </Tooltip>

            <ConfirmDialog
                open={open}
                setOpen={setOpen}
                ok='Exportar'
                cancel="Sair"
                title={pagina.nome}
                body={"Confirma exportar pagina? Isso pode levar alguns minutos"}
                execute={handleExportClick}
            />
        </React.Fragment>
    )
}